import RouteConfig from '../../abs/config/routeConfig';
export default {
  chart: {
    height: 400
  },
  title: {
    text: '',
    useHTML: true
  },
  xAxis: {
    labels: {
      rotation: -35
    }
  },
  credits: {
    href: RouteConfig.chartCnabsLink,
    text: 'CNABS',
    mapText: '',
    mapTextFull: '',
    position: {
      x: -12,
      y: -12
    }
  },
  series: []
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSChart/defaultOption.ts